<template>
  <div class="pt-10">
    <router-link
      :to="{name: 'create-address'}"
      class="bg-teal-400 p-2 text-white rounded hover:bg-white hover:text-teal-400"
    >{{ $t('NewAddress')}}</router-link>
    <div class="flex w-auto pt-4 pb-4">
      <table class="w-full border-collapse">
        <thead>
          <tr>
            <th
              class="p-3 font-semibold text-gray-800 border-b border-gray-300 hidden lg:table-cell"
            >{{ $t('Type')}}</th>
            <th
              class="p-3 font-semibold text-gray-800 border-b border-gray-300 hidden lg:table-cell"
            >{{ $t('Address1')}}</th>
            <th
              class="p-3 font-semibold text-gray-800 border-b border-gray-300 hidden lg:table-cell"
            >{{ $t('Address2')}}</th>
            <th
              class="p-3 font-semibold text-gray-800 border-b border-gray-300 hidden lg:table-cell"
            >{{ $t('City')}}</th>
            <th
              class="p-3 font-semibold text-gray-800 border-b border-gray-300 hidden lg:table-cell"
            >{{ $t('State')}}</th>
            <th
              class="p-3 font-semibold text-gray-800 border-b border-gray-300 hidden lg:table-cell"
            >{{ $t('Country')}}</th>
            <th
              class="p-3 font-semibold text-gray-800 border-b border-gray-300 hidden lg:table-cell"
            >{{ $t('Zip')}}</th>
            <th
              class="p-3 font-semibold text-gray-800 border-b border-gray-300 hidden lg:table-cell"
            >{{ $t('DefaultAddress')}}</th>
            <th
              class="p-3 font-semibold text-gray-800 border-b border-gray-300 hidden lg:table-cell"
            ></th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="address in addresses"
            :key="address.id"
            class="bg-white lg:hover:bg-gray-100 flex lg:table-row flex-row lg:flex-row flex-wrap lg:flex-no-wrap mb-10 lg:mb-0"
          >
            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border-b block lg:table-cell relative lg:static"
            >{{ address.type }}</td>
            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border-b block lg:table-cell relative lg:static"
            >{{ address.address_1 }}</td>
            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border-b block lg:table-cell relative lg:static"
            >{{ address.address_2 }}</td>
            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border-b block lg:table-cell relative lg:static"
            >{{ address.city }}</td>
            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border-b block lg:table-cell relative lg:static"
            >{{ address.country }}</td>
            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border-b block lg:table-cell relative lg:static"
            >{{ address.zip }}</td>
            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border-b block lg:table-cell relative lg:static"
            >{{ address.isDefault }}</td>
            <td
              class="w-full lg:w-auto p-3 text-gray-800 text-center border-b block lg:table-cell relative lg:static"
            >
              <router-link :to="{ name: 'address', params: { id: address.id } }">
                <span class="p-2">
                  <i class="fa fa-edit text-gray-600"></i>
                </span>
              </router-link>
              <button @click="deleteAddress(address.id)">
                <!-- <span class="p-2"> -->
                <i class="fa fa-trash text-gray-600"></i>
                <!-- </span> -->
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      addresses: [],
      id: this.$route.params.id
    };
  },
  watch: {
    $route() {
      this.getAddresses();
      if (this.id) {
        this.deleteAddress(this.id);
      }
    }
  },
  mounted() {
    this.getAddresses();
  },
  methods: {
    deleteAddress(id) {
      axios
        .delete(`${process.env.VUE_APP_API}/address/${id}`)
        .then(() => this.$router.back())
        .then(
          this.$notify({
            group: "address",
            title: "Address",
            text: "Adresse wurde gelöscht"
          })
        )
        .catch(error => console.log(error));
    },
    getAddresses() {
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + localStorage.getItem("access_token");

      axios.get(`${process.env.VUE_APP_API}/user`).then(response => {
        this.addresses = response.data.data.address;
      });
    }
  }
};
</script>

<style></style>
